import { IAccountDictionaryApi } from '@/types';

export class AccountDictionaryItem {
    id: number;
    login?: string;
    name: string;

    constructor(data: IAccountDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.login = data.login;
    }
}
